export default __webpack_public_path__ + "d656ad2ca6563ae35bc852b6132a6009.png";